export {
  useGetRecommendedUpNext,
  useGetSuggestedShowsAndFilms,
  getSuggestedShowsAndFilms,
} from './RecommendationService'
export type {
  RecommendedUpNextContent,
  RecommendedUpNextResult,
  SuggestedShowsAndFilmsContent,
  SuggestedShowsAndFilmsResult,
} from './types'
